import { ethers } from 'ethers';
import { ERC20Abi, NETWORKS } from '../config/contracts';

export const getNetworkName = (chainId: number | null): string => {
  if (!chainId) return 'Unknown Network';
  const network = Object.values(NETWORKS).find(n => n.chainId === chainId);
  return network?.name || 'Unknown Network';
};

export const getNetworkColor = (chainId: number | null): 'success' | 'error' | 'warning' => {
  if (!chainId) return 'error';
  return chainId === 1 || chainId === 137 ? 'success' : 'warning';
};

export function isAddressEqual(address?: string, other?: string) {
  if (address === undefined || other === undefined) {
    return false;
  }

  if (!ethers.utils.isAddress(address) || !ethers.utils.isAddress(other)) {
    return false;
  }

  return address.toLowerCase() === other.toLowerCase();
}

export const formatAddress = (address: string, isSmall: boolean = false): string => {
  if (!address) return '';
  return isSmall ? `${address.slice(0, 4)}...${address.slice(-2)}` : `${address.slice(0, 6)}...${address.slice(-4)}`;
};
  // 验证以太坊地址
export   const isValidAddress = (address: string): boolean => {
    try {
      return ethers.utils.isAddress(address);
    } catch {
      return false;
    }
  };

export const generateAvatarColor = (address: string): string => {
  const hash = address.slice(2, 8);
  const hue = parseInt(hash, 16) % 360;
  return `hsl(${hue}, 70%, 50%)`;
};

export   const getPermissionText = (permission: number) => {
    switch (permission) {
      case 0: return 'NONE';
      case 1: return 'READ_ONLY';
      case 2: return 'READ_WRITE';
      default: return `NONE (${permission})`;
    }
  };

export   const getPermissionColor = (permission: number) => {
    switch (permission) {
      case 0: return 'error';
      case 1: return 'warning';
      case 2: return 'success';
      default: return 'default';
    }
  };

export const getKYCStatusText = (status: number) => {
  switch (status) {
    case 0: return 'NONE';
    case 1: return 'PENDING';
    case 2: return 'APPROVED';
    case 3: return 'REJECTED';
    default: return `NONE (${status})`;
  }
};

export const getKYCStatusColor = (status: number) => {
  switch (status) {
    case 0: return 'default';
    case 1: return 'warning';
    case 2: return 'success';
    case 3: return 'error';
    default: return 'default';
  }
};

export const getERC20Balance = async (
  contractAddress?: string,
  account?: string,
  provider?: ethers.providers.BaseProvider
) => {
  if (
    contractAddress === undefined ||
    account === undefined ||
    provider === undefined
  ) {
    return;
  }

  if (contractAddress === '0x0000000000000000000000000000000000000000') {
    return await provider.getBalance(account);
  }

  const contract = new ethers.Contract(contractAddress, ERC20Abi, provider);

  return await contract.balanceOf(account);
};

export function isValidDecimal(value: string, decimals: number) {
  return new RegExp(`^\\d+(\.)?(\\d{1,${decimals}})?$`).test(value);
}

export function getAmountInWei(amount: number) {
  return ethers.utils.parseEther(amount.toString());
}
export function getAmountFromWei(amount: number) {
  return Number(ethers.utils.formatUnits(amount.toString(), "ether"));
}
export const bytesToFileSize = (bytes: number): string => {
  if (bytes === 0) {
    return "0";
  }

  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};
/**
 * 将数字转换为百分比字符串 (例如, 25 转换为 '2.5%').
 * @param value 要转换的数字.
 * @returns 格式化后的百分比字符串.
 */
export function numberToPercentage(value: number): string {
  const percentage = value / 10;
  // 为避免浮点精度问题，将结果四舍五入到最多6位小数
  const rounded = Math.round(percentage * 1e6) / 1e6;
  return `${rounded}%`;
}